import React from 'react';
import { MobileDatePicker } from '@mui/x-date-pickers';
import TextInput from '../TextInput/TextInput';

interface IProps {
  label: string;
  value: Date | null;
  error?: boolean;
  helperText?: string | null;
  /* eslint-disable-next-line */
  onChangeValue?: any;
  disabled?: boolean;
  disablePast?: boolean;
  minDate?: Date | null;
}

const DatePickerInput = ({
  label,
  value,
  helperText,
  error,
  onChangeValue = () => {},
  disabled,
  disablePast = true,
  minDate = null,
}: IProps) => {
  const handleChangeDate = (newValue: string | null | Date) => {
    if (newValue) {
      onChangeValue(new Date(newValue));
    }
  };

  return (
    <MobileDatePicker
      disabled={disabled}
      label={label}
      disablePast={disablePast}
      value={value}
      onChange={handleChangeDate}
      // Without an explicit floor the picker is only bounded by `disablePast`:
      // a form that turns it off can reach any past date, which the previous
      // unconditional "today" silently forbade.
      minDate={minDate ?? (disablePast ? new Date() : undefined)}
      slots={{
        textField: (params) => (
          // eslint-disable-next-line
          // @ts-ignore
          <TextInput
            style={error ? {borderRadius: '10px', boxShadow: 'rgba(249, 71, 60, 0.5) 0 0 0 0.2rem'} : {}}
            {...params}
            helperText={helperText}
            error={error}
          />
        ),
      }}
    />
  );
};

export default DatePickerInput;
